import React from 'react';
import Filter from './filter';
import { getHeaders } from '../../services/fetch';
import { LOCATION_DATA_GET_SUMMARY_URL } from '../../services/config';
import QueryString from 'qs';
import Report from '../../views/report';
import Classes from "../../views/report/styles";
import { translate } from 'react-i18next';

class Reporting extends React.Component {

  static async getSummary(filter) {
    const response = await fetch(
      `${LOCATION_DATA_GET_SUMMARY_URL}?${QueryString.stringify(filter)}`,
      {
        headers: {
          ...getHeaders()
        }
      }
    );
    return response.json();
  }

  state = {
    filter: null,
    isLoading: false
  };

  onFilter = async (filter) => {
    await new Promise(resolve => this.setState({
      isLoading: true
    }, resolve));
    try {
      const summary = await Reporting.getSummary(filter);
      if (summary.message) {
        throw new Error(summary.message);
      }
      await new Promise(resolve => this.setState({
        summary
      }, resolve));
    } catch(error) {
      await new Promise(resolve => this.setState({
        error
      }, resolve));
    }
    await new Promise(resolve => this.setState({
      isLoading: false
    }, resolve));
  };

  render() {
    const { t } = this.props;
    return (
      <div style={{ padding: 15 }}>
        <div className={Classes.header}>
          <h3>{t('header')}</h3>
        </div>
        <Filter onFilter={this.onFilter} />
        {
          this.state.isLoading ? <p>Loading...</p> : null
        }
        {
          !this.state.error && !this.state.isLoading && this.state.summary ? (
            <Report report={this.state.summary} />
          ) : null
        }
      </div>
    )
  }

}

export default translate(['report'])(Reporting);



// WEBPACK FOOTER //
// ./src/app/report/index.js